// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component } from '@angular/core';

@Component({
  selector: 'app-spl-grp-menu',
  standalone: false,
  templateUrl: './spl-grp-menu.component.html',
  styleUrl: './spl-grp-menu.component.css'
})
export class SplGrpMenuComponent {

}
